import { useCompare } from "./CompareContext";
import { useCatalogData } from "./CatalogDataContext";

export function CompareTray() {
  const {
    selected,
    toggle,
    clear,
    openCompare,
    selectionError,
    clearSelectionError,
  } = useCompare();
  const { models } = useCatalogData();
  if (selected.length === 0 && !selectionError) return null;

  return (
    <div className="compare-bar">
      {selectionError ? (
        <p className="compare-bar-error" role="alert">
          {selectionError}
          <button
            type="button"
            className="compare-bar-error-dismiss"
            onClick={clearSelectionError}
            aria-label="Dismiss"
          >
            ×
          </button>
        </p>
      ) : null}
      {selected.length > 0 ? (
        <>
          <strong
            style={{
              fontSize: "0.72rem",
              fontFamily: "var(--mono)",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              fontWeight: 500,
            }}
          >
            Compare ({selected.length}/4)
          </strong>
          <div className="chips">
            {selected.map((id) => {
              const m = models.find((x) => x.id === id);
              return (
                <span className="chip" key={id}>
                  {m?.name ?? id}
                  <button
                    type="button"
                    onClick={() => toggle(id)}
                    aria-label="Remove"
                  >
                    ×
                  </button>
                </span>
              );
            })}
          </div>
          <button type="button" className="btn ghost sm" onClick={clear}>
            Clear
          </button>
          <button
            type="button"
            className="btn sm"
            disabled={selected.length < 2}
            onClick={() => openCompare()}
          >
            Open compare
          </button>
        </>
      ) : null}
    </div>
  );
}
